import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdCampaignsPage.scss";
import api from "../api/axios";
import { buildAdvertiserPublicUrl, copyTextToClipboard } from "../utils/publicLinks";

export default function AdCampaignsPage() {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [linkLoadingId, setLinkLoadingId] = useState(null);
    const [linkStatus, setLinkStatus] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        setError("");

        api.get("/admin/ad-campaigns")
            .then(({ data }) => {
                setCampaigns(data.campaigns || []);
            })
            .catch(() => {
                setError("Не удалось загрузить список рекламных кампаний.");
                setCampaigns([]);
            })
            .finally(() => setLoading(false));
    }, []);

    const handleOpenCampaign = (id) => {
        navigate(`/ad-campaigns/${id}/locations`);
    };

    const handleCopyClientLink = async (campaignId) => {
        setLinkLoadingId(campaignId);
        setLinkStatus(null);

        try {
            const { data } = await api.get(`/advertisers/generate/${campaignId}`);
            const publicUrl = buildAdvertiserPublicUrl(data?.hash, data?.url);

            await copyTextToClipboard(publicUrl);
            setLinkStatus({
                campaignId,
                type: "success",
                text: "Ссылка для клиента скопирована.",
            });
        } catch (err) {
            setLinkStatus({
                campaignId,
                type: "error",
                text:
                    err?.response?.data?.error ||
                    err?.message ||
                    "Не удалось сформировать ссылку клиента.",
            });
        } finally {
            setLinkLoadingId(null);
        }
    };

    return (
        <div className="ad-campaigns-page">
            <div className="ad-campaigns-header">
                <h2>Рекламные кампании</h2>
                <p className="ad-campaigns-subtitle">
                    Список роликов с категорией <code>ad</code>, включая кампании без размещений.
                </p>
            </div>

            {loading && <div className="ad-campaigns-loading">Загрузка...</div>}

            {error && !loading && (
                <div className="ad-campaigns-error">
                    {error}
                </div>
            )}

            {!loading && !error && campaigns.length === 0 && (
                <div className="ad-campaigns-empty">
                    Рекламных кампаний не найдено.
                </div>
            )}

            {!loading && !error && campaigns.length > 0 && (
                <div className="ad-campaigns-list">
                    {campaigns.map((campaign) => (
                        <div className="ad-campaign-card" key={campaign.id}>
                            <div className="ad-campaign-card-main">
                                <div className="ad-campaign-card-title">
                                    {campaign.title}
                                </div>
                                <div className="ad-campaign-card-meta">
                                    <span>id: {campaign.id}</span>
                                </div>
                            </div>

                            <div className="ad-campaign-card-stats">
                                <div className="ad-campaign-stat">
                                    <div className="ad-campaign-stat-label">Компаний</div>
                                    <div className="ad-campaign-stat-value">
                                        {campaign.companiesCount}
                                    </div>
                                </div>
                                <div className="ad-campaign-stat">
                                    <div className="ad-campaign-stat-label">Точек</div>
                                    <div className="ad-campaign-stat-value">
                                        {campaign.placementsCount}
                                    </div>
                                </div>
                                <div className="ad-campaign-stat">
                                    <div className="ad-campaign-stat-label">С отчётами</div>
                                    <div className="ad-campaign-stat-value">
                                        {campaign.reportedCount}
                                    </div>
                                </div>
                            </div>

                            <div className="ad-campaign-card-footer">
                                <button
                                    type="button"
                                    className="ad-campaign-card-button ad-campaign-card-button--ghost"
                                    onClick={() => handleCopyClientLink(campaign.id)}
                                    disabled={linkLoadingId === campaign.id}
                                >
                                    {linkLoadingId === campaign.id
                                        ? "Формируем..."
                                        : "Ссылка клиенту"}
                                </button>
                                <button
                                    type="button"
                                    className="ad-campaign-card-button"
                                    onClick={() => handleOpenCampaign(campaign.id)}
                                >
                                    Открыть точки
                                </button>
                            </div>

                            {linkStatus?.campaignId === campaign.id && (
                                <div
                                    className={
                                        "ad-campaign-card-feedback " +
                                        (linkStatus.type === "error"
                                            ? "ad-campaign-card-feedback--error"
                                            : "ad-campaign-card-feedback--success")
                                    }
                                >
                                    {linkStatus.text}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
